<template>
  <v-app id="app">
    <DialogLoginFailed ref="dlgError"></DialogLoginFailed>
    <router-view/>
    <div class="allover" v-if="idleIsActive">
      <div style="margin-top: 20%">
        <center>
          <SelfBuildingSquareSpinner></SelfBuildingSquareSpinner>
          <br><br>
          <span class="idleText" v-if="idleText && idleText.length > 0">{{idleText}}</span>
        </center>
      </div>
      <v-container justify-center fill-height>
        <v-layout row>
          <v-flex cols="12" md="6" v-if="progress != 100" class="pa-4" style="margin-top: 10%">
            <v-progress-linear
              color="light-blue"
              height="10"
              :value="progress"
              striped
            ></v-progress-linear>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-app>
</template>
<script>
  import Vue from 'vue'
  import {SelfBuildingSquareSpinner} from 'epic-spinners'
  import DialogLoginFailed from './components/dialogs/DialogLoginFailed'

  export default {
    name: 'App',
    components: {DialogLoginFailed, SelfBuildingSquareSpinner},
    mounted () {
      // this.version = Vue.config.data.VERSION
      Vue.prototype.$api.getJQuery()('#myToolbar').removeClass('scrollerOn')
      Vue.prototype.$api.getJQuery()('#myToolbar').addClass('scrollerOff')
      Vue.prototype.$api.getJQuery()(document).scroll(function (a, b, c) {
        if (Vue.prototype.$api.getJQuery()(window).scrollTop() > 40) {
          Vue.prototype.$api.getJQuery()('#myToolbar').removeClass('scrollerOff')
          Vue.prototype.$api.getJQuery()('#myToolbar').addClass('scrollerOn')
        } else if (Vue.prototype.$api.getJQuery()(window).scrollTop() < 40) {
          Vue.prototype.$api.getJQuery()('#myToolbar').removeClass('scrollerOn')
          Vue.prototype.$api.getJQuery()('#myToolbar').addClass('scrollerOff')
        }
      })
    },
    destroyed () {
      Vue.prototype.$eventHub.$off('OnIdle', this.OnStartIdle)
      Vue.prototype.$eventHub.$off('OnLogin', this.onLogin)
      Vue.prototype.$eventHub.$off('OnProgress', this.OnProgress)
      Vue.prototype.$eventHub.$off('errorDlg', this.OnErrorDlg)
    },
    created () {
      Vue.prototype.$eventHub.$on('OnIdle', this.OnStartIdle)
      Vue.prototype.$eventHub.$on('OnLogin', this.onLogin)
      Vue.prototype.$eventHub.$on('OnProgress', this.OnProgress)
      Vue.prototype.$eventHub.$on('errorDlg', this.OnErrorDlg)
    },
    data: () => ({
      showToolbar: true,
      dialog: false,
      isLogin: false,
      idleText: 'Examenis',
      progress: 100,
      idleIsActive: false
    }),
    methods: {
      OnErrorDlg (error) {
        console.log('OnErrorDlg', error)
        var desc = JSON.stringify(error)
        if (error.status !== 200) {
          if (error.statusText || error.message) {
            desc = ''
          }
          if (error.statusText) {
            desc += error.statusText
          }
          if (error.message) {
            desc += error.message
          }
          this.$refs.dlgError.open({
            newName: 'nn',
            title: 'Es ist Fehler aufgetreten (' + error.status + ' - ' + error.statusText + ')',
            type: 'Type',
            code: error.status,
            description: desc
          })
        }
        if (error && error.success === false) {
          if (error.message) {
            desc = error.message
          }
          this.$refs.dlgError.open({
            newName: 'nn',
            title: 'Es ist Fehler aufgetreten',
            type: 'Type',
            description: desc
          })
        }
      },
      OnProgress (progress) {
        console.log('OnProgress', progress)
        this.progress = progress
        if (progress === 100) {
          this.showIdle = false
        } else {
          this.showIdle = true
        }
      },
      OnStartIdle (data) {
        if (typeof data === 'boolean') {
          this.idleText = ''
          this.idleIsActive = data
        } else if (Array.isArray(data)) {
          this.idleText = ''
          this.idleIsActive = data[0]
          this.idleText = data[1]
        }
      },
      onLogin (login) {
        this.isLogin = !login
      }
    }
  }
</script>

<style>
  @import "../node_modules/katex/dist/katex.min.css";

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue